import angular from "angular";

let mod = angular
    .module('trainRoutesService', [])
    .service('trainRoutesService', ['$http', '$q', controller]);

function controller($http, $q) {

    this.getTrainRoutes = function (depStationCode, depDate, trainNumber) {
        let defer = $q.defer();
        $http
            .post('/railways-api/get-train-route', {
                DepartureStation: depStationCode,
                DepartureDate: depDate,
                TrainNumber: trainNumber
            })
            .then(
                function (r) {
                    let routes = [];
                    for (let i = 0; i < r.data.res.Routes.length; i++) {
                        routes.push(r.data.res.Routes[i]);
                    }
                    defer.resolve(routes);
                },
                function (error) {
                    defer.reject(error);
                }
            );
        return defer.promise;
    };

    this.getDistance = function (depStationCode, arrStationCode, routes) {

        let startStation = null, endStation = null;

        for (let i = 0; i < routes.length; i++) {
            if (!startStation) {
                for (let j = 0; j < routes[i].Stop.length; j++) {
                    if (routes[i].Stop[j].Code == depStationCode) {
                        startStation = {
                            routeInd: i,
                            stationInd: j,
                            station: routes[i].Stop[j]
                        };
                        break;
                    }
                }
            }
        }

        for (let i = 0; i < routes.length; i++) {
            if (!endStation) {
                for (let j = 0; j < routes[i].Stop.length; j++) {
                    if (routes[i].Stop[j].Code == arrStationCode) {
                        endStation = {
                            routeInd: i,
                            stationInd: j,
                            station: routes[i].Stop[j]
                        };
                        break;
                    }
                }
            }
        }

        if (startStation && endStation) {
            return endStation.station.Distance - startStation.station.Distance;
        }

        return null;
    };

}

export default mod.name;



// WEBPACK FOOTER //
// ./resources/assets/modules/booking-module/trainRoutesService/trainRoutesService.js